import { render, staticRenderFns } from "./Paytm.vue?vue&type=template&id=d197622e&scoped=true&"
import script from "./Paytm.vue?vue&type=script&lang=js&"
export * from "./Paytm.vue?vue&type=script&lang=js&"
import style0 from "./Paytm.vue?vue&type=style&index=0&id=d197622e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d197622e",
  null
  
)

export default component.exports